<template>
  <fragment>
    <app-header>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'users.overview', params: { 'id': id }}"
        active-class=""
        :class="{
          active: $route.name === 'users.overview',
        }"
      >
        <a class="nav-link">Overview</a>
      </router-link>
      <router-link
        v-if="$can('read permissions')"
        tag="li"
        class="nav-item"
        :to="{ name: 'users.single.permissions', params: { 'id': id }}"
        active-class=""
        :class="{
          active: $route.name === 'users.single.access',
        }"
      >
        <a class="nav-link">Access Permissions</a>
      </router-link>
      <router-link
        v-if="$can('read timesheets') || user.id === authorized.id"
        tag="li"
        class="nav-item"
        :to="{ name: 'users.timesheet', params: { 'id': id }}"
      >
        <a class="nav-link">Timesheet</a>
      </router-link>
      <router-link
        v-if="user.id === authorized.id || $isA('admin')"
        tag="li"
        class="nav-item"
        :to="{ name: 'users.scheduled-tasks', params: { 'id': id }}"
      >
        <a class="nav-link">Scheduled Tasks</a>
      </router-link>
    </ul>

    <div class="container container-fluid my-4">
      <h2>{{ title }}</h2>
      <router-view v-if="loaded" />
    </div>
  </fragment>
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import {user} from 'mixins'

    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },

        mixins: [user],

        props: [
            'id'
        ],

        data: function () {
            return {
              loaded: false
            }
        },

        async created () {
            this.$validator.localize('en', {
                custom: {
                    password_confirmation: {
                        is: 'The password confirmation field does not match.'
                    }
                }
            })

            try {
                await this.getUser(this.id)
                this.loaded = true
            } catch (error) {
                this.$router.replace({ name: 'users.index' })
            }
        },


        computed: {
            ...mapState('user', ['user', 'authorized']),

            title () {
              if (this.user && this.user.name) {
                return this.user.name
              }

              return ''
            }
        },

        methods: {
            ...mapActions('user', ['getUser'])
        }
    }
</script>
